@if (incomeTaxEntity$ | async; as incomeTaxEntity) {
  <form [formGroup]="formGroup">
    @if (eigenWoningen.length > 0) {
      <div formArrayName="eigenWoningen">
        @for (item of eigenWoningen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row" style="--bs-gutter-x: 0.5rem;">
              <div class="col-auto row" formGroupName="adres" style="--bs-gutter-x: 0.5rem;">
                <snelstart-ui-text-form-control class="custom-input-100"
                                                formControlName="postcode"
                                                id="postcode-' + {{i}}"
                                                label="Postcode"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control [decimals]="0"
                                                  class="custom-input-75"
                                                  formControlName="huisNummer"
                                                  id="huisNummer-' + {{i}}"
                                                  label="Huisnr"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-text-form-control class="custom-input-75"
                                                formControlName="huisNummerToevoeging"
                                                id="huisNummerToevoeging-' + {{i}}"
                                                label="Toev."
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-text-form-control class="custom-input-250"
                                                formControlName="woonplaats"
                                                id="woonplaats-' + {{i}}"
                                                label="Woonplaats"
                >
                </snelstart-ui-text-form-control>
              </div>
              <snelstart-ui-number-form-control [decimals]="0"
                                                align="right"
                                                class="custom-input-200"
                                                formControlName="woz"
                                                id="woz-' + {{i}}"
                                                label="Woz-waarde 1-1-{{incomeTaxEntity?.year! -1}}"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [showAllDecimals]="true"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="percentageEigendom"
                                                id="percentageEigendom-' + {{i}}"
                                                label="Eigendom"
                                                postfix="%"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="deleteEigenWoning(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'firstrowbutton col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDelete-' + {{i}}"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>

            <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
              <div class="col-auto row" formGroupName="bewoondePeriode" style="--bs-gutter-x: 0.5rem;">
                <snelstart-ui-date-form-control class="custom-input-150"
                                                formControlName="begindatum"
                                                id="begindatum-' + {{i}}"
                                                label="Bewoond vanaf"
                                                placeholder="dd-mm-{{incomeTaxEntity?.year!}}"
                >
                </snelstart-ui-date-form-control>
                <snelstart-ui-date-form-control class="custom-input-150"
                                                formControlName="einddatum"
                                                id="einddatum-' + {{i}}"
                                                label="Bewoond t/m"
                                                placeholder="dd-mm-{{incomeTaxEntity?.year!}}"
                >
                </snelstart-ui-date-form-control>
              </div>
              <snelstart-ui-button (click)="this.showDialog(i)"
                                   class="custom-input-200 pt-3"
                                   icon="plus"
                                   type="secondary">Verkoop/Leegstand?
              </snelstart-ui-button>
              <snelstart-ui-number-form-control [decimals]="0"
                                                align="right"
                                                class="custom-input-200"
                                                formControlName="betaaldeErfpachtCanon"
                                                id="betaaldeErfpachtCanon-' + {{i}}"
                                                label="Betaalde erfpacht"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                class="custom-input-150"
                                                formControlName="aanhorigheid"
                                                id="aanhorigheid-' + {{i}}"
                                                label="Aanhorigheid"
              >
              </snelstart-ui-select-form-control>
            </div>
          </div>
        }
      </div>
    }
    <snelstart-ui-button (click)="addEigenWoning()" class="snelstart-ui-button" icon="plus"
                         type="link">Woning toevoegen
    </snelstart-ui-button>
  </form>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="eigenWoningBijzonderheden" size="lg"
                                  title="Gegevens verkoop en/of leegstand eigen woning">
    <snelstart-ui-dialog-body>
      @if (incomeTaxEntity$ | async; as incomeTaxEntity) {
        <form [formGroup]="formGroup">
          @if (eigenWoningen.length > 0) {
            <div formArrayName="eigenWoningen">
              @for (item of eigenWoningen.controls; track item; let i = $index) {
                <div [formGroupName]="i">
                  @if (i === index) {
                    @if (item.getRawValue().bewoondePeriode.begindatum !== undefined && item.getRawValue().bewoondePeriode.einddatum !== undefined) {
                      <div class="row">
                        <div class="col-7 pt-1">
                          <p>Is er in {{ incomeTaxEntity.year! }} sprake van verkoop en/of leegstand van de woning?</p>
                        </div>
                        <div class="col-5">
                          <snelstart-ui-select-form-control [options]="redenLeegstand"
                                                            class="custom-input-250"
                                                            formControlName="leegstand"
                                                            id="leegstand-' + i"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>
                    }

                    @if (item.getRawValue().bewoondePeriode.begindatum === undefined || item.getRawValue().bewoondePeriode.einddatum === undefined) {
                      <div class="row">
                        <div class="col-7 pt-1">
                          <p>Is er in {{ incomeTaxEntity.year! }} sprake van verkoop en/of leegstand van de woning?</p>
                        </div>
                        <div class="col-5">
                          <snelstart-ui-select-form-control [options]="redenLeegstand"
                                                            class="custom-input-250"
                                                            formControlName="leegstand"
                                                            id="leegstand-' + i"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>
                    }

                    @if (item.getRawValue().leegstand === OnroerendeZaakLeegstand.AANBOUW) {
                      <div class="row">
                        <div class="col-7 pt-1">
                          <p>Is de onroerende zaak gekocht in {{ incomeTaxEntity.year! }}? Vul de aankoopdatum in:</p>
                        </div>
                        <div class="col-5">
                          <snelstart-ui-date-form-control class="custom-input-250"
                                                          formControlName="datumGekocht"
                                                          id="datumGekocht-' + i"
                                                          label=""
                                                          placeholder="dd-mm-{{incomeTaxEntity.year!}}"
                          >
                          </snelstart-ui-date-form-control>
                        </div>
                      </div>
                    }

                    @if (item.getRawValue().datumGekocht !== null) {
                      <div class="row">
                        <div class="col-7 pt-1">
                          <p>Vul de aankoopprijs en -kosten in.</p>
                        </div>
                        <div class="col-5">
                          <snelstart-ui-number-form-control [decimals]="0"
                                                            align="right"
                                                            class="custom-input-250"
                                                            formControlName="aankoopkosten"
                                                            placeholder=""
                                                            prefix="€"
                          >
                          </snelstart-ui-number-form-control>
                        </div>
                      </div>
                    }

                    @if (item.getRawValue().leegstand === OnroerendeZaakLeegstand.VERKOOP) {
                      <div class="row">
                        <div class="col-7 pt-1">
                          <p>Is de onroerende zaak verkocht in {{ incomeTaxEntity.year! }}? Vul de verkoopdatum in</p>
                        </div>
                        <div class="col-5">
                          <snelstart-ui-date-form-control class="custom-input-250"
                                                          formControlName="datumVerkocht"
                                                          id="datumVerkocht"
                                                          label=""
                                                          placeholder="dd-mm-{{incomeTaxEntity.year!}}"
                          >
                          </snelstart-ui-date-form-control>
                        </div>
                      </div>
                    }

                    @if (item.getRawValue().datumVerkocht !== null) {
                      <div class="row">
                        <div class="col-7 pt-1">
                          <p>Vul de verkoopopbrengst exclusief kosten in.</p>
                        </div>
                        <div class="col-5">
                          <snelstart-ui-number-form-control [decimals]="0"
                                                            align="right"
                                                            class="custom-input-250"
                                                            formControlName="verkoopkosten"
                                                            placeholder=""
                                                            prefix="€"
                          >
                          </snelstart-ui-number-form-control>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-7">
                          <p>Bedrag eigenwoningschuld bij verkoop</p>
                        </div>
                        <div class="col-5">
                          <snelstart-ui-number-form-control [decimals]="0"
                                                            align="right"
                                                            class="custom-input-250"
                                                            formControlName="eigenWoningSchuldVerkochteWoning"
                                                            id="eigenWoningSchuldVerkochteWoning"
                                                            prefix="€"
                          >
                          </snelstart-ui-number-form-control>
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          }
        </form>
      }
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
      <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
      <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
